import { EnciHtmlEditor } from '../enci.htmleditor.js';

// Configuration constants
export const CONFIG = {
  // Version control
  version: '20240905',
  // Component selectors
  selectors: {
    editor: 'form-emailer-message',
  },
};

class EmailTemplatesManager {
  constructor() {
    this.dotNetHelper = null;
    this.editor = null;
    this.lastContent = '';
  }

  async initialize(dotNetHelper) {
    // Dispose of any existing instance first
    if (this.editor) {
      this.editor.dispose();
      this.editor = null;
    }

    this.dotNetHelper = dotNetHelper;

    try {
      await this.initializeHtmlEditor();
    } catch (error) {
      console.error('Error initializing EmailTemplatesManager:', error);
    }
  }

  dispose() {
    if (this.editor) {
      this.editor.dispose();
      this.editor = null;
    }
    this.dotNetHelper = null;
  }

  async initializeHtmlEditor() {
    try {
      // Create a new instance of EnciHtmlEditor
      this.editor = EnciHtmlEditor.create(CONFIG.selectors.editor, {
        // valueType: 'markdown',
        height: 'calc(100%-48px)',
      });

      if (!this.editor) {
        throw new Error('Failed to initialize HTML editor');
      }

      // Add content change listener
      this.editor.onContentChange(content => {
        this.lastContent = content;
        // this.updatePreview(content);
        // Notify .NET component
        if (this.dotNetHelper) {
          this.dotNetHelper.invokeMethodAsync('OnEditorContentChanged', content);
        }
      });
    } catch (error) {
      console.error('Error initializing HTML editor:', error);
      throw error;
    }
  }

  updatePreview(content) {
    const iframe = document.getElementById('emailPreview');
    if (iframe) {
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <style>
              body {
                font-family: Arial, sans-serif;
                line-height: 1.6;
                padding: 20px;
                margin: 0;
              }
              p { margin-bottom: 1em; }
              strong { font-weight: bold; }
              em { font-style: italic; }
              ul, ol { margin: 1em 0; padding-left: 2em; }
              li { margin: 0.5em 0; }
              a { color: #007bff; text-decoration: none; }
              a:hover { text-decoration: underline; }
              hr { border: 0; border-top: 1px solid #eee; margin: 2em 0; }
              blockquote {
                border-left: 4px solid #eee;
                margin: 1em 0;
                padding-left: 1em;
                color: #666;
              }
            </style>
          </head>
          <body>
            ${content}
          </body>
        </html>
      `);
      doc.close();
    }
  }

  clearEditor() {
    if (this.editor) {
      this.editor.clear();
    }
  }

  setEditorValue(content) {
    if (this.editor) {
      this.editor.setValue(content);
    }
  }

  getEditorValue() {
    if (this.editor) {
      return this.editor.getValue();
    }
    return '';
  }
}

export const emailTemplatesManager = new EmailTemplatesManager();

export const loadComponent = async dotNetHelper => {
  await emailTemplatesManager.initialize(dotNetHelper);
};
